import React from 'react';
import { useParams } from 'react-router';

import Translation from '@swf/components/Translation/Translation';
import { UserClubRole } from '@swf/core/types/Poker';
import { useCheckUserClubRole } from '@swf/poker';

import type { Props } from '../Container';

import CloseOrLeaveClub from './CloseOrLeaveClub/CloseOrLeaveClub';
import EmailNotifications from './EmailNotifications/EmailNotifications';
import {
  TXTWCL_Delete_Club,
  TXTWCL_To_delete_the_clubX_please_con_ELL
} from './Settings.messages.json';
import styles from './Settings.scss';

const Settings: React.FC<Props> = () => {
  const { clubId } = useParams<{ clubId: string }>();
  const isManager = useCheckUserClubRole(clubId, [UserClubRole.Manager]);

  return (
    <div>
      <EmailNotifications />
      <CloseOrLeaveClub />
      {isManager && (
        <div className={styles.deleteClubSection}>
          <h2 className={styles.deleteClubTitle}>
            <Translation {...TXTWCL_Delete_Club} />
          </h2>
          <p className={styles.deleteClubInstructions}>
            <Translation {...TXTWCL_To_delete_the_clubX_please_con_ELL} values={{ 0: '' }} />
            <span className={styles.deleteClubEmail}>support@pokerstars.com</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default Settings;
